import React from "react";

import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import { ONCREATETREE } from "api/mutations";
import { TreeInput } from "api/types";
import { useSnack } from "hooks/useSnack";

import NewTreePageForm, { type TreePageFormValues } from "./components/NewTreePageForm";

const NewTreePage = () => {
  const { onSnackError, onSnackSuccess } = useSnack();
  const navigate = useNavigate();

  const [createTree, { loading }] = useMutation<{
    data: TreeInput;
  }>(ONCREATETREE);

  async function onSubmit(values: TreePageFormValues) {
    if (!values.geoValues) {
      onSnackError("Ops! Please fill a address");
      return;
    }
    const { geoValues, yearAdded } = values;
    try {
      await createTree({
        variables: {
          data: {
            latitude: geoValues.coordinates[1],
            longitude: geoValues.coordinates[0],
            address: geoValues.place,
            yearAdded,
          },
        },
      });
      onSnackSuccess("Success! Tree created!");
      navigate("/");
    } catch (error) {
      onSnackError("Ops! Something went wrong...");
    }
  }

  return <NewTreePageForm loading={loading} onSubmit={onSubmit} />;
};

export default NewTreePage;
